export default __webpack_public_path__ + "static/media/left.ef840762.svg";